import { Pause, Play, SkipForward } from "@phosphor-icons/react";
import { Button } from "../../app/components/ui/Button";

interface ExecutionControlsProps {
  /** The world/editor is ready and the program may be run or stepped. */
  ready: boolean;
  /** The program is currently auto-advancing. */
  running: boolean;
  onRun: () => void;
  onPause: () => void;
  onStep: () => void;
}

/**
 * Run / Pause / Step controls shared by the IDE lesson and demo views. While a
 * program is auto-advancing the Run button becomes Pause; stepping is disabled
 * until the run is paused or stopped.
 */
export function ExecutionControls({
  ready,
  running,
  onRun,
  onPause,
  onStep,
}: ExecutionControlsProps) {
  return (
    <>
      {running ? (
        <Button
          variant="secondary"
          icon={<Pause weight="fill" size={16} />}
          onClick={onPause}
        >
          Pause
        </Button>
      ) : (
        <Button
          variant="primary"
          icon={<Play weight="fill" size={16} />}
          disabled={!ready}
          onClick={onRun}
        >
          Run
        </Button>
      )}
      <Button
        variant="secondary"
        icon={<SkipForward weight="fill" size={16} />}
        disabled={!ready || running}
        onClick={onStep}
      >
        Step
      </Button>
    </>
  );
}
